import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, ModuleFE_Thunderstorm, mouseInteractivity_PopUp, Thunder } from '@nu-art/thunderstorm-frontend/index';
import './EditorHeader_AdvisorContext.scss';
import { ICONS } from '@app/styles';
export class EditorHeader_AdvisorContext extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.searchableItem = nextProps.searchableItem;
        state.editMode = !!nextProps.editMode;
        state.itemActions = nextProps.itemActions;
        state.editModeActions = nextProps.editModeActions;
        return state;
    }
    // ######################## Logic ########################
    openItemActions = (e) => {
        const box = e.currentTarget.getBoundingClientRect();
        const model = {
            id: 'editor-advisor-context__item-actions',
            originPos: { x: box.right, y: box.y + (box.height / 2) },
            modalPos: { x: 1, y: 1 },
            content: () => {
                return this.state.itemActions.map((action, index) => {
                    return _jsx(Button, { variant: 'text', onClick: async () => {
                            await action.action();
                            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        }, children: action.label }, index);
                });
            },
            offset: { x: 5, y: -(box.height / 2) }
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_H_C, { className: 'advisor-context-editor-header', children: [this.renderTitle(), this.renderItemActions(), this.renderEditModeActions()] });
    }
    renderTitle = () => {
        const item = this.state.editable.item;
        let label = item._id ? item.label : `New ${this.state.searchableItem.entityLabel}`;
        const localEnv = Thunder.getInstance().getConfig().label?.toLowerCase() === 'local';
        if (localEnv)
            label += ` (${item._id})`;
        return _jsxs(LL_V_L, { className: 'advisor-context-editor-header__title', children: [_jsx("div", { className: 'advisor-context-editor-header__title__label', onClick: () => {
                        if (!localEnv || !item._id)
                            return;
                        return ModuleFE_Thunderstorm.copyToClipboard(item._id);
                    }, children: label }), _jsxs(LL_H_C, { className: 'advisor-context-editor-header__title__hierarchy', children: [_jsx("span", { className: 'advisor-context-editor-header__title__hierarchy__entity', children: this.state.searchableItem.entityLabel }), "in", _jsx("span", { className: 'advisor-context-editor-header__title__hierarchy__group', children: this.state.searchableItem.groupId })] })] });
    };
    renderItemActions = () => {
        if (!this.state.itemActions?.length || this.state.editMode)
            return;
        return _jsx(ICONS.more.component, { onClick: this.openItemActions });
    };
    renderEditModeActions = () => {
        if (!this.state.editModeActions?.length || !this.state.editMode)
            return;
        return _jsx(LL_H_C, { className: 'advisor-context-editor-header__edit-mode-actions', children: this.state.editModeActions.map((action, index) => {
                return _jsx(Button, { variant: 'primary', onClick: action.action, children: action.label }, index);
            }) });
    };
}
//# sourceMappingURL=EditorHeader_AdvisorContext.js.map